import { createAction, props } from '@ngrx/store';
import { Alert, AlertType } from '@surface-elements/shared/alert-system/domain';
import { AlertConfig } from '@surface-elements/shared/alert-system/domain';

export const addAlert = createAction(
  '[Alert] Add Alert',
  props<{ alert: Omit<Alert, 'id' | 'timestamp'> }>(),
);

export const addAlertSuccess = createAction(
  '[Alert] Add Alert Success',
  props<{ alert: Alert }>(),
);

export const removeAlert = createAction(
  '[Alert] Remove Alert',
  props<{ id: string }>(),
);

export const removeAlertSuccess = createAction(
  '[Alert] Remove Alert Success',
  props<{ id: string }>(),
);

export const clearAlerts = createAction(
  '[Alert] Clear Alerts',
  props<{ type?: AlertType }>(),
);

export const clearAlertsSuccess = createAction('[Alert] Clear Alerts Success');

export const updateConfig = createAction(
  '[Alert] Update Config',
  props<{ config: Partial<AlertConfig> }>(),
);

export const loadPersistedAlerts = createAction(
  '[Alert] Load Persisted Alerts',
);

export const loadPersistedAlertsSuccess = createAction(
  '[Alert] Load Persisted Alerts Success',
  props<{ alerts: Alert[] }>(),
);

export const persistAlert = createAction(
  '[Alert] Persist Alert',
  props<{ alert: Alert }>(),
);

export const dismissAlert = createAction(
  '[Alert] Dismiss Alert',
  props<{ id: string }>(),
);
